/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CarveOutTrackingPresetCounts
 */
export interface CarveOutTrackingPresetCounts {
    /**
     * Count of tracking rows in the Not Submitted preset bucket.
     */
    notSubmitted: number;
    /**
     * Count of tracking rows in the In Review preset bucket.
     */
    inReview: number;
    /**
     * Count of tracking rows in the Following preset bucket.
     */
    following: number;
}

/**
 * Check if a given object implements the CarveOutTrackingPresetCounts interface.
 */
export function instanceOfCarveOutTrackingPresetCounts(value: object): value is CarveOutTrackingPresetCounts {
    if (!('notSubmitted' in value) || value['notSubmitted'] === undefined) return false;
    if (!('inReview' in value) || value['inReview'] === undefined) return false;
    if (!('following' in value) || value['following'] === undefined) return false;
    return true;
}

export function CarveOutTrackingPresetCountsFromJSON(json: any): CarveOutTrackingPresetCounts {
    return CarveOutTrackingPresetCountsFromJSONTyped(json, false);
}

export function CarveOutTrackingPresetCountsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarveOutTrackingPresetCounts {
    if (json == null) {
        return json;
    }
    return {
        
        'notSubmitted': json['notSubmitted'],
        'inReview': json['inReview'],
        'following': json['following'],
    };
}

export function CarveOutTrackingPresetCountsToJSON(json: any): CarveOutTrackingPresetCounts {
    return CarveOutTrackingPresetCountsToJSONTyped(json, false);
}

export function CarveOutTrackingPresetCountsToJSONTyped(value?: CarveOutTrackingPresetCounts | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'notSubmitted': value['notSubmitted'],
        'inReview': value['inReview'],
        'following': value['following'],
    };
}

